import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { Service } from '../../../services';
@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.component.html',
  styleUrls: ['./company-information.component.sass']
})
export class CompanyInformationComponent implements OnInit {

  constructor(private services: Service,private global:GlobalService,private loadingScreenService :LoadingScreenService) { }
  
  public accountData;
  public fullName;
  public celNum;
  public selectBan;
  isLoading = false;
  @Input() name:string;
  @Input() cel:string;
  @Input() homeNum:string;
  @Input() email:string;
  ngOnInit() {
    if(this.global.sessionReview()==true){
       this.selectBan=atob(sessionStorage.getItem("selectBan"));
    }
  }

  continueInfo2() {
    this.global.validateSession();
    if(this.email==''){
      this.email='info@claropr.com';
    }
    if (this.cel === '' || this.homeNum === null) {
        this.global.notif('Debe colocar un Número de Celular.');
    }
    else {
        if (this.cel.length !== 10) {
            this.global.notif('El Número de Celular debe estar en un formato válido.');
        }
        else {
            if (this.homeNum === '' || this.homeNum === null) {
                this.global.notif('Debe colocar un Número de Teléfono del Hogar.');
            }
            else {
                if (this.homeNum.length !== 10) {
                    this.global.notif('El Número Teléfono del Hogar debe estar en un formato válido.');
                }
                else {
                     this.loadingScreenService.startLoading();
                     this.services.updatePersonalData(sessionStorage.getItem("token"),btoa(this.selectBan),btoa(this.cel),btoa(this.homeNum),btoa(this.email)).subscribe(data =>{
                      if(data.hasError ==false){
                        this.loadingScreenService.stopLoading(); 
                        sessionStorage.setItem("updatePersonalData",btoa(JSON.stringify(data)));
                        this.global.notif(data.errorDesc);
                      }
                      else{
                        this.loadingScreenService.stopLoading();   
                        this.global.notif(data.errorDesc);
                      }
                    });   
                }
            }
        }
    }
  }
  // getPersonalData(account){
  //   this.services.getPersonalData(sessionStorage.getItem("token"),account).subscribe(data =>{
  //     if(data.HasError ==false){
  //         sessionStorage.setItem("GetPersonalData",btoa(JSON.stringify(data)));
  //         this.accountData=JSON.parse(atob(sessionStorage.getItem("GetPersonalData")));
  //         this.fullName=this.accountData.FirstName+' '+this.accountData.LastName+' '+this.accountData.LastSecondName;
  //         this.celNum=this.accountData.CelularPhone;
  //         this.homeNum=this.accountData.PhoneNumber;
  //     }
  //     else{
  //       this.global.notif(data.ErrorDesc);
  //     }
  //   });
  // }
}